import {Helmet} from '@dr.pogodin/react-helmet';

import {isString} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';
import {DmsDataGrid, usePermissions} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function WarehouseMarketingCode() {
  const navigate = useNavigate();

  const [warehouseDictionaryCreate] = usePermissions({
    permissionKeys: ['warehouseDictionaryCreate'],
  });

  const actionCallback: ActionCallback = ({actionKey, rowId}) => {
    switch (actionKey) {
      case 'redirectDetail':
        if (isString(rowId)) {
          navigate(
            composePath(settingsRoutes.warehousesMarketingCodeDetail, {params: {id: rowId}})
          );
        }
        break;
    }
  };

  const header: SettingsTemplateHeader = {
    title: i18n.t('entity.warehouse.labels.marketingCode'),
    actions: [
      {
        type: 'button',
        title: i18n.t('entity.warehouse.actions.newMarketingCode'),
        onClick: () => navigate(settingsRoutes.warehousesMarketingCodeCreate),
        isDisabled: !warehouseDictionaryCreate,
        tooltip: !warehouseDictionaryCreate
          ? i18n.t('module.warehouse.label.missingWarehouseDictionaryCreatePermission')
          : undefined,
      },
    ],
  };

  return (
    <>
      <Helmet title={i18n.t('entity.warehouse.labels.marketingCodes')} />
      <SettingsTemplate
        data-testid={testIds.settings.workshopPresetsCategory('template')}
        header={header}
      >
        <DmsDataGrid
          gridCode="marketing-code"
          actionCallback={actionCallback}
          emptyState={{
            headline: i18n.t('page.warehouseDetail.labels.emptyAssortment'),
          }}
        />
      </SettingsTemplate>
    </>
  );
}
